export default __webpack_public_path__ + "static/media/plud-ic.9f94e6a1.svg";